export default "__VITE_ASSET__66ac7ef1__"